import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { SunIcon, MoonIcon } from '../icons';

const ThemeSwitch = ({ className = '' }) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <div className={`relative inline-flex items-center ${className}`}>
      {/* Background container */}
      <div 
        className="relative w-[72px] h-[40px] bg-[#F7F7F7] dark:bg-[#252525] rounded-xl shadow-inner cursor-pointer transition-colors duration-200"
        onClick={toggleTheme}
      >
        {/* Toggle button */}
        <div 
          className={`absolute top-1 w-8 h-8 bg-[#FFFFFF] dark:bg-[#121212] rounded-lg shadow-md transition-transform duration-200 ease-in-out ${
            isDark ? 'translate-x-9' : 'translate-x-1'
          }`}
        >
          {/* Icon container */}
          <div className="flex items-center justify-center w-full h-full">
            {isDark ? (
              <MoonIcon size={16} className="text-[#121212] dark:text-[#D0D0D0]" />
            ) : (
              <SunIcon size={16} className="text-[#121212] dark:text-[#D0D0D0]" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemeSwitch;
